import Model from "./base/model";

class SimulationTable extends Model {
  resourceName() {
    return "simulation_tables";
  }

  fields() {
    return {
      shipper_transporter_id: "",
      modal: "",
      table: "",
      date_start: "",
      date_end: "",
      actual: "",
      user_import_id: "",
      user_shipper_id: "",
      user_transporter_id: "",
      shipper_approval: "",
      transporter_approval: "",
      shipper_justification: "",
      transporter_justification: "",
      destination: "",
      ad_valorem: "",
      km_ranges: "",
      kg_ranges: "",
      vehicle: "",
      vehicle_type: "",
      vehicle_option: "",
      vehicle_option_id: "",
      destination_description: "",
      transporter_id: "",
      transporter: "",
      total_value: "",
      weight_shipping_value: "",
      rates_value: "",
      rates: "",
      lead_time: "",
      business_days: "",
      validity: "",
      readjustment: "",
      reverse: "",
      cif_fob: "",
      transfer: "",

      minimum_weight_shipping: "", //less_than
      option_calcule: "", //less_than

      shipper: "", //readjustment
      transporter: "", //readjustment
      simulation_table: "", //readjustment

      city: "", //find_cities
      uf: "", //find_cities
      origin: "", //distance_cities
      destiny: "", //distance_cities
      origin_city: "", //distance_google, distance_cities, search
      origin_state: "", //distance_google, distance_cities, search
      destiny_city: "", //distance_google, distance_cities, search
      destiny_state: "", //distance_google, distance_cities, search
      vehicle_type: "", //search
      invoice_amount: "", //search
      distance: "", //search
      weight: "", //search
      receiver: "", //search
      shipper_id: "", //search
      supplier_id: "", //search
      toll: "", //search
      toll_icms: "", //search
      ad_valorem_icms: "", //search
      reverse: "", //search
      cities: "", //search
      farm: "", //search

      simulation_advalorem: {jsonApi: "hasMany", type: "simulation_advalorem"},
      simulation_gris: {jsonApi: "hasMany", type: "simulation_gris"},
      simulation_km_range: {jsonApi: "hasMany", type: "simulation_km_ranges"},

      simulation_kg_range: {jsonApi: "hasMany", type: "simulation_kg_ranges"},

      tde: {jsonApi: "hasMany", type: "simulation_table_tde"},
      trt: {jsonApi: "hasMany", type: "simulation_table_trt"},
      suframa: {jsonApi: "hasMany", type: "simulation_table_suframa"},
      river_insurance: {jsonApi: "hasMany", type: "simulation_table_river_insurance"},

      prolongation: {jsonApi: "hasMany", type: "simulation_table_prolongation"},

      files: {jsonApi: "hasMany", type: "simulation_tables_files"},

      destination: "", //destinations -> less_than
      state_id: "", //destinations -> less_than
      description: "", //destinations -> less_than
      lead_time: "", //destinations -> less_than
      ad_valorem: "", //destinations -> less_than
      gris: "", //destinations -> less_than
      trt: "", //destinations -> less_than
      tde: "", //destinations -> less_than
      tas: "", //destinations -> less_than
      emex: "", //destinations -> less_than
      toll: "", //destinations -> less_than
      suframa: "", //destinations -> less_than
      river_insurance: "", //destinations -> less_than
      minimum_value_gris: "", //destinations -> less_than
      minimum_value_trt: "", //destinations -> less_than
      minimum_value_tde: "", //destinations -> less_than
      minimum_value_emex: "", //destinations -> less_than
      minimum_value_ad_valorem: "", //destinations -> less_than

      collection_fee: "", //destinations -> less_than and less_than reverse
      collection_fee_excess: "", //destinations -> less_than reverse
      collection_fee_excess_kg: "", //destinations -> less_than reverse
      minimum_rate: "", //destinations -> less_than reverse

      minimum_value_toll: "", //destinations -> less_than
      tub: "", //destinations -> less_than
      dispatch_fee: "", //destinations -> less_than
      re_delivery: "", //destinations -> less_than
      devolution: "", //destinations -> less_than
      insurance: "", //destinations -> less_than
      refaturation: "", //destinations -> less_than
      scheduling: "", //destinations -> less_than
      palletization: "", //destinations -> less_than
      minimum_value_scheduling: "", //destinations -> less_than
      add_value_emex: "", //destinations -> less_than
      add_value_palletization: "", //destinations -> less_than
      tpf: "", //destinations -> less_than
      tlc: "", //destinations -> less_than
      tad: "", //destinations -> less_than
      tda: "", //destinations -> less_than
      chemical_product: "", //destinations -> less_than
      tzr: "", //destinations -> less_than
      confirmation_fee: "", //destinations -> less_than
      icms: "", //destinations -> less_than
      kg_guarantee: "", //destinations -> less_than
      sec_cat: "", //destinations -> less_than

      simulation_integra_orders_addresses: "", //multiple_cities

      simulation_table_id: "", //prolongation
      date: "", //prolongation
      shipper_fantasy_name: "",
      dimensional_weight: "",
      dimensional_weight_factor: "",

      shipper_ids: "",
    };
  }

  async findCities(data) {
    return this.request(
      `simulation_integra/find_cities`,
      "POST",
      {},
      data
    );
  }

  async distanceCities(data) {
    return this.request(
      `simulation_integra/distance_cities`,
      "POST",
      {},
      data
    );
  }

  async search(data) {
    return this.request(
      `simulation_integra/search`,
      "POST",
      {},
      data
    );
  }

  async get(control) {
    return this.request(
      `simulation_integra/simulation_table`,
      "GET",
      control,
      null
    );
  }

  async getFullTruckload(control) {
    return this.request(
      `simulation_integra/simulation_table/full_truckload`,
      "GET",
      control,
      null
    );
  }

  async detailsFullTruckload(id, control) {
    return this.request(
      `simulation_integra/simulation_table/full_truckload/${id}`,
      "GET",
      control,
      null
    );
  }

  async getFullTruckloadReverse(control) {
    return this.request(
      `simulation_integra/simulation_table/full_truckload_reverse`,
      "GET",
      control,
      null
    );
  }

  async detailsFullTruckloadReverse(id, control) {
    return this.request(
      `simulation_integra/simulation_table/full_truckload_reverse/${id}`,
      "GET",
      control,
      null
    );
  }

  async getLessThanTruckload(control) {
    return this.request(
      `simulation_integra/simulation_table/less_than_truckload`,
      "GET",
      control,
      null
    );
  }

  async detailsLessThanTruckload(id, control) {
    return this.request(
      `simulation_integra/simulation_table/less_than_truckload/${id}`,
      "GET",
      control,
      null
    );
  }

  async getLessThanTruckloadReverse(control) {
    return this.request(
      `simulation_integra/simulation_table/less_than_truckload_reverse`,
      "GET",
      control,
      null
    );
  }

  async detailsLessThanTruckloadReverse(id, control) {
    return this.request(
      `simulation_integra/simulation_table/less_than_truckload_reverse/${id}`,
      "GET",
      control,
      null
    );
  }

  async approveTable(id, data) {
    return this.request(
      `simulation_integra/approve_table/${id}`,
      "POST",
      {},
      data
    );
  }

  async readjustmentFullTruckload(data) {
    return this.request(
      `simulation_integra/simulation_table/full_truckload_readjustment`,
      "POST",
      {},
      data
    );
  }

  async readjustmentFullTruckloadReverse(data) {
    return this.request(
      `simulation_integra/simulation_table/full_truckload_reverse_readjustment`,
      "POST",
      {},
      data
    );
  }

  async readjustmentLessThanTruckload(data) {
    return this.request(
      `simulation_integra/simulation_table/less_than_truckload_readjustment`,
      "POST",
      {},
      data
    );
  }

  async readjustmentLessThanTruckloadReverse(data) {
    return this.request(
      `simulation_integra/simulation_table/less_than_truckload_reverse_readjustment`,
      "POST",
      {},
      data
    );
  }

  async tableProlongation(data) {
    return this.request(
      `simulation_integra/simulation_table_prolongation`,
      "POST",
      {},
      data
    );
  }

}

export default new SimulationTable();
